export { default as DefaultAvatar } from '@src/assets/images/avatars/avatar.png';

// Refactor Environment Variables
export const PLATFORM_API_URL = process.env.REACT_APP_PLATFORM_API_URL;
export const PLATFORM_NEW_API_URL = process.env.REACT_APP_PLATFORM_NEW_API_URL;

//Specific API URLs
export const PLATFORM_SCHEDULING_API_URL = `${PLATFORM_NEW_API_URL}/scheduling/v3`;
export const PLATFORM_IDENTITY_API_URL = `${PLATFORM_NEW_API_URL}/identity/v3`;
export const PLATFORM_CHECKOUT_API_URL = `${PLATFORM_SCHEDULING_API_URL}/checkout`;

// BK-2909 phase 2: tenant + audit moved off the legacy `api.<env>` host onto the canonical
// `api-platform.<env>` host, reached through their own base-path mapping. The in-path segments
// (`/v3/tenant/...`, `/api/v3/audit/...`) are unchanged — only the host+prefix moved, because
// the mapping strips the base path before the API matches the route.
export const PLATFORM_TENANT_API_URL = `${PLATFORM_NEW_API_URL}/tenant`;
export const PLATFORM_AUDIT_API_URL = `${PLATFORM_NEW_API_URL}/audit`;

// Fallback Environment Variables
// alias + auth migrated to the platform host (BK-3669); kept here for the
// service-worker offline-replay match and jwtService auth-header injection.
// Must track PLATFORM_TENANT_API_URL — service-worker.js matches it with startsWith().
export const ALIAS_API_BASE_URL = `${PLATFORM_TENANT_API_URL}/v3/tenant/alias`;
export const AUTH_API_URL = `${PLATFORM_NEW_API_URL}/auth/v3`;

export const API_TENANT_PUBLIC_URL = 'https://oapv2.alyni.com/v1/api/external';
export const APP_DOMAIN = process.env.REACT_APP_DOMAIN || 'bukkii.io';
export const BOOKING_URL = process.env.REACT_APP_BOOKING_URL;
export const USER_URL = process.env.REACT_APP_USER_URL;
export const NEW_CALENDAR_URL = process.env.REACT_APP_NEW_CALENDAR_URL;
export const GOOGLE_REVIEW_URL = process.env.REACT_APP_URL_GET_REVIEW;

export const VERCEL_CNAME = process.env.REACT_APP_VERCEL_CNAME;
export const VERCEL_AVALUE = process.env.REACT_APP_VERCEL_AVALUE;

export const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY;

export const SITE_ID = 'SUPER_USER';
export const INTERNAL_ADMIN_ROLE = 'ROLE_ADMIN';
export const SHOP_ADMIN_ROLE = 'ROLE_SHOP_ADMIN';
export const CUSTOMER_ROLE = 'ROLE_CUSTOMER';

/** Canonical Cognito user-pool group names. Import instead of bare strings to catch typos at the call site. */
export const CognitoGroups = Object.freeze({
  TenantAdmin: 'TenantAdmin',
  Staff: 'Staff',
  ReadOnly: 'ReadOnly',
  SuperAdmin: 'SuperAdmin',
  Support: 'Support',
  // Removed in BK-2739: Receptionist, SupportAdmin (use Support instead), Guest
});

export const DATE_FORMAT_FRIENDLY = 'D, M j';
export const YEAR_MONTH_DATE_FORMAT = 'YYYY-MM-DD';
export const REGEX_SPECIAL_CHARACTER = /[`!@#$%^&*()+\-=\[\]{};':"\\|,<>\/?~ ]/g;
export const ALIAS_NAME_MAX_LENGTH = 63;

export const CookieKeys = {
  user: 'user_info',
  accessToken: 'access_token',
  shop: 'shop',
  tabSetting: 'tabSetting',
  refreshToken: 'refresh_token',
  tenantId: 'tenant_id',
};

export const BookingSteps = {
  ChooseProduct: 1,
  DateAndTime: 2,
  ChooseProvider: 3,
  Login: 4,
  LoginByEmail: 5,
  SignUp: 6,
  Customer: 7,
  Confirmation: 8,
  BookSuccess: 9,
};

// export const DefaultAvatar = `https://image-api.${APP_DOMAIN}/no-avatar.png`;

export const COLORS = [
  { hex: '#8FC8FF', hexLighter: '#E9F3FF' },
  { hex: '#F7A6B3', hexLighter: '#FDEDEF' },
  { hex: '#C3A5E7', hexLighter: '#F9F7FE' },
  { hex: '#FFC05E', hexLighter: '#FFF2DE' },
  { hex: '#57C0B5', hexLighter: '#DDF2F0' },
  { hex: '#FFBBE0', hexLighter: '#FFF1F9' },
  { hex: '#FFBFA3', hexLighter: '#FFEFE8' },
  { hex: '#FFD6A5', hexLighter: '#FFF4E9' },
  { hex: '#AFCBFF', hexLighter: '#F1F6FF' },
  { hex: '#FF9CEE', hexLighter: '#FFF0FB' },
  { hex: '#D5AAFF', hexLighter: '#F8F3FF' },
  { hex: '#FFE5B4', hexLighter: '#FFF8ED' },
  { hex: '#F5B9A3', hexLighter: '#FFF0EB' },
  { hex: '#B8D1FF', hexLighter: '#F2F7FF' },
  { hex: '#E2A5FF', hexLighter: '#FAF0FF' },
  { hex: '#FFD2DD', hexLighter: '#FFF6F8' },
  { hex: '#7FD1D1', hexLighter: '#E5F6F6' },
  { hex: '#F6C37B', hexLighter: '#FFF6E7' },
  { hex: '#95D2C6', hexLighter: '#E6F7F4' },
  { hex: '#FFB7B2', hexLighter: '#FFEFEF' },
  { hex: '#B5B9FF', hexLighter: '#F3F4FF' },
  { hex: '#FFA8A8', hexLighter: '#FFECEC' },
];

export const AppointmentLabels = ['No Label', 'Anyone', 'Requested'];

// export const avatarDefault = 'https://www.pixsy.com/wp-content/uploads/2021/04/ben-sweet-2LowviVHZ-E-unsplash-1.jpeg';

export const SpecialErrors = {
  AliasAlreadyUsed: 'AliasAlreadyUsed',
  TokenIsExpired: 'TokenIsExpired',
  NotAuthorizedException: 'NotAuthorizedException',
  ErrorHttp401: 'error.http.401',
  Forbidden: 'Forbidden',
};

export const ReviewType = {
  google: 'google',
  bukkii: 'bukkii',
};

export const RewardType = {
  Reward: 'Reward',
  Redeem: 'Redeem',
};

export const NotificationType = {
  newBooking: 'ShopReceiveNewAppointment',
  rescheduled: 'ShopReceiveRescheduleAppointment',
  review: 'ShopReceiveReview',
  canceled: 'ShopReceiveCancelAppointment',
  newRequestBooking: 'ShopReceiveNewRequestAppointment',
};

export const CustomerNotificationType = {
  newBooking: 'CustomerNewAppointment',
  rescheduled: 'CustomerRescheduleAppointment',
  canceled: 'CustomerCancelAppointment',
  remind: 'CustomerReminderAppointment',
  review: 'CustomerReviewAppointment',
  happy: 'CustomerHappyBirthday',
};

export const NotificationTypeArray = [
  NotificationType.newBooking,
  NotificationType.rescheduled,
  NotificationType.canceled,
  NotificationType.review,
  NotificationType.newRequestBooking,
];

export const NotificationAction = {
  Accept: 'accept',
  Decline: 'decline',
};

export const NotificationStatus = {
  Read: 'READ',
  Received: 'RECEIVED',
};

export const REVIEW_TAB = {
  all: '1',
  oap: '2',
  google: '3',
};

export const APP_AND_INTEGRATE = {
  payment: 'payment',
  bookingWidget: 'bookingWidget',
  googleReview: 'googleReview',
  googleReverse: 'googleReverse',
};

export const StatusContent = {
  UNCONFIRMED: 'Unconfirmed',
  CONFIRMED: 'Confirmed',
  CHECK_IN: 'Check-in',
  WAITING: 'Waiting',
  IN_SERVICE: 'In Service',
  DECLINED: 'Declined',
  DELETED: 'Cancel',
  DONE: 'Completed',
  NO_SHOW: 'No show',
};

export const SettingDomain = {
  SelectSubdomain: 'selectSubdomain',
  Config: 'config',
  GoLive: 'goLive',
};

export const SettingDomainSteps = {
  FirstStep: SettingDomain.SelectSubdomain,
  SecondStep: SettingDomain.Config,
  LastStep: SettingDomain.GoLive,
};
